import { render, staticRenderFns } from "./SalesClosuresTable.vue?vue&type=template&id=3baf1b62&scoped=true"
import script from "./SalesClosuresTable.vue?vue&type=script&lang=js"
export * from "./SalesClosuresTable.vue?vue&type=script&lang=js"
import style0 from "./SalesClosuresTable.scoped.css?vue&type=style&index=0&id=3baf1b62&scoped=true&lang=css&external"
import style1 from "./SalesClosuresTable.global.css?vue&type=style&index=1&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf1b62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3baf1b62')) {
      api.createRecord('3baf1b62', component.options)
    } else {
      api.reload('3baf1b62', component.options)
    }
    module.hot.accept("./SalesClosuresTable.vue?vue&type=template&id=3baf1b62&scoped=true", function () {
      api.rerender('3baf1b62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/closings-details/components/SalesClosuresTable.vue"
export default component.exports